import React from "react";
import { Card, Row, Col, Typography, theme, Tooltip } from "antd";
import { useContext } from "react";
import { ProfileContext } from "Common/hooks/context/ProfileContext";
import { useNavigate } from "react-router-dom";
import {
  ClockCircleOutlined,
  TeamOutlined,
  ArrowRightOutlined,
} from "@ant-design/icons";
//import "Common/Style/style.scss";
const { Title, Text } = Typography;
const { useToken } = theme;
const NewEmployees = () => {
  const { token } = useToken();
  const navigate = useNavigate();
  const { isProfileComplete } = useContext(ProfileContext);
  const isBlocked = !isProfileComplete;
  const cardOptions = [
    {
      key: "search",
      title: "Search Employees on Platform",
      icon: <ClockCircleOutlined />,
      color: token.colorWarning,
      route: "/new-employees/search",
      description:
        "Search and review employees who are registered or pending approval.",
    },
    {
      key: "invite",
      title: "Invite Employees to Platform",
      icon: <TeamOutlined />,
      color: token.colorPrimary,
      route: "/new-employees/invite",
      description:
        "Send invitations to employees to join the platform and manage access.",
    },
  ];
  return (
    <Card className="page-card business-groups-container">
      <Title level={3} className="page-title">
        New Employees
      </Title>
      <Text type="secondary" className="page-subtitle">
        Manage employee invitations and review registration requests
      </Text>
      <Row
        gutter={[24, 24]}
        className="card-grid"
        style={{
          pointerEvents: isBlocked ? "none" : "auto",
          opacity: isBlocked ? 0.6 : 1,
        }}
      >
        {cardOptions.map((option) => {
          const disabled = isBlocked;
          return (
            <Col xs={24} sm={12} md={12} lg={8} key={option.key}>
              <Tooltip
                title={disabled ? "Complete your profile to access this option" : ""}
              >
                <Card
                  hoverable
                  className="option-card"
                  onClick={() => !disabled && navigate(option.route)}
                  style={{
                    border: `4px solid ${option.color}`,
                    cursor: disabled ? "not-allowed" : "pointer",
                    opacity: disabled ? 0.6 : 1,
                  }}
                >
                  <div className="option-card-content">
                    <div
                      className="icon-circle"
                      style={{
                        backgroundColor: `${option.color}20`,
                        color: option.color,
                      }}
                    >
                      {option.icon}
                    </div>
                    <Title level={4} className="option-title">
                      {option.title}
                    </Title>
                    <Text type="secondary" className="option-description">
                      {option.description}
                    </Text>
                    <div className="option-link" style={{ color: option.color }}>
                      <Text strong>
                        Go to section <ArrowRightOutlined />
                      </Text>
                    </div>
                  </div>
                </Card>
              </Tooltip>
            </Col>
          );
        })}
      </Row>
    </Card>
  );
};
export default NewEmployees;

